import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { STATUS_TYPE } from '../../../global/constants';
import { AlignCenter, FlexBetween, FlexCenter, LineClamp } from '../../../global/commonStyle';

interface Props {
  isOverdue?: boolean;
  isHide?: boolean;
  isGap?: boolean;
  isTaskItem?: boolean;
  isShowCompletedTask?: boolean;
  isSelected?: boolean;
  color?: string;
  isActive?: boolean;
  showSubTask?: boolean;
  isActiveSubTask?: boolean;
  isApplyMargin?: boolean;
  showRightBorder?: boolean;
  statusType?: number;
  applyPadding?: boolean;
  isCreateView?: boolean;
}

const StatusDropdown = styled.div`
  display: flex;
  gap: var(--space-2);
`;

const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
`;

const TaskFormation = styled.div``;

const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  padding: var(--space-20) var(--space-24) var(--space-24);
  ${(props: Props) =>
    props.isHide &&
    css`
      gap: var(--space-0);
    `}
  ${mobile_xl(css<Props>`
    padding: var(--space-8) ${({ isCreateView }) => (isCreateView ? 'var(--space-24)' : 'var(--space-20)')}
      var(--space-96);
  `)}
`;

const ItemBlock = styled.div<Props>`
  ${(props: Props) =>
    props.isHide &&
    css`
      display: none;
    `}
`;

const Tasklist = styled.div<Props>`
  ${FlexBetween}
  margin-bottom: var(--space-2);
  ${(props: Props) =>
    props.isHide &&
    css`
      display: none;
    `}
  ${(props: Props) =>
    props.isGap &&
    css`
      margin-top: var(--space-20);
    `}
    ${mobile_xl(css`
    align-items: flex-start;
    margin-bottom: var(--space-4);
  `)}
`;

const Title = styled.h1<{ applyFontSize?: boolean }>`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
  ${({ applyFontSize }) =>
    applyFontSize &&
    css`
      ${Typography.body_md_medium}
    `}
`;

const TitleSection = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-8);
  border-radius: var(--border-radius-full);
  position: relative;
  z-index: var(--z-index-base);
  ${(props: Props) =>
    props.applyPadding &&
    css`
      padding: var(--space-4) var(--space-12) var(--space-4) var(--space-6);
      margin-left: -6px;
    `}
`;

const IconHidden = styled.div`
  position: absolute;
  left: -15px;
  top: 9px;
  cursor: pointer;
  svg {
    opacity: 0;
  }
  ${mobile_xl(css`
    svg {
      display: none;
    }
  `)}
  ${(props: Props) =>
    props.showSubTask &&
    css`
      display: none;
    `}
`;

const TaskContent = styled.div<Props>`
  position: relative;
  ${FlexBetween}
  border: 0.5px solid transparent;
  padding: var(--space-3) var(--space-5);
  margin: -1px -10px var(--space-0);
  border-radius: var(--border-radius-full);
  gap: var(--space-40);
  &:hover {
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    box-shadow: var(--shadow-card);
    ${IconHidden} svg {
      opacity: 1;
    }
    .plus-icon {
      visibility: visible;
    }
    .task-input {
      background-color: var(--text-white);
    }
  }
  ${(props: Props) =>
    props.isSelected &&
    css`
      background: var(--background-primary);
      border: 0.5px solid var(--border-primary);
      box-shadow: var(--shadow-card);
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      background: var(--background-primary);
      border: 0.5px solid var(--border-primary);
      box-shadow: var(--shadow-card);
    `}
      ${(props: Props) =>
    props.showSubTask &&
    css`
      margin-left: var(--space-0);
      ${mobile_xl(css`
        padding-left: var(--space-8) !important;
        width: calc(100vw - 64px) !important;
        margin: var(--space-0) !important;
      `)}
      &:hover ${IconHidden} svg {
        opacity: 0;
      }
    `}
  ${mobile_xl(css<Props>`
    gap: var(--space-8);
    border: none;
    padding: var(--space-10) var(--space-0);
    margin-left: -4px;
    width: calc(100vw - 36px);
    .assign {
      display: flex;
    }
    .webdropdown {
      display: none;
    }
    &:hover {
      border: none !important;
      box-shadow: none !important;
      background: none !important;
      ${IconHidden} svg {
        opacity: 1;
      }
      .plus-icon {
        display: none;
      }
    }
  `)}
`;

const TaskItemWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css`
    width: 100%;
    justify-content: space-between;
    gap: var(--space-18);
  `)}
`;

const Form = styled.div<Props>`
  ${AlignCenter}
  gap: ${(props: Props) => (props.isTaskItem ? 'var(--space-6)' : 'var(--space-10)')};
  ${mobile_xl(css`
    gap: var(--space-6);
  `)}
`;
const ButtonIcon = styled.div`
  padding: var(--space-4);
  border-radius: var(--border-radius-12);
  display: flex;
  &:hover {
    background-color: var(--neutral-secondary);
    input {
      filter: brightness(var(--brightness-value));
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-all;
  a {
    color: var(--text-link);
    text-decoration: underline;
    display: inline-block;
    &:hover {
      text-decoration: none;
    }
  }
  ${mobile_xl(css`
    ${Typography.body_md_medium};
  `)}
`;

const AssignGroup = styled.div`
  padding-block: var(--space-2);
  ul {
    ${AlignCenter}
    flex-wrap: wrap;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
    width: max-content;
  }
  li {
    margin-left: -10px;
    border-radius: var(--border-radius-full);
    background-color: var(--background-muted);
  }
  .blank-plus-icon {
    z-index: var(--z-index-base);
    width: 20px;
    height: 20px;
    ${FlexCenter}
    border: 1px solid var(--background-secondary);
  }
  .plus-icon {
    visibility: hidden;
    z-index: var(--z-index-base);
    width: 20px;
    height: 20px;
    border: 1px solid var(--background-secondary);
    ${FlexCenter}
    &:first-child {
      margin-left: -10px;
    }
  }
  ${mobile_xl(css`
    padding-block: var(--space-0);

    .plus-icon {
      display: none;
    }
  `)}
`;

const AvatarImage = styled.div`
  ${AlignCenter}
  border-radius: var(--border-radius-full);
  > div > img {
    max-width: 100%;
  }
`;

const Deadline = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-12);
  svg {
    vertical-align: middle;
  }
  ${mobile_xl(css`
    display: none;
    gap: var(--space-12);
    flex-wrap: wrap;
  `)}
`;

const DeadBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  span {
    ${AlignCenter}
    gap: var(--space-4);
  }
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Text = styled.p<Props>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  white-space: nowrap;
  ${(props: Props) =>
    props.isOverdue &&
    css`
      color: var(--accent-error);
    `}
`;

const ShowHide = styled.a`
  ${Typography.body_md}
  color: var(--text-secondary);
  cursor: pointer;
  max-width: 146px;
  width: 100%;
  padding-top: var(--space-6);
  &:hover {
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    max-width: max-content;
    padding: var(--space-6) var(--space-0) var(--space-6) var(--space-12);
    line-height: 20px;
  `)}
  ${(props: Props) =>
    props.showSubTask &&
    css`
      padding: var(--space-4) var(--space-0) var(--space-4) var(--space-10);
    `}
`;
const ShowTask = styled.div`
  display: flex;
  gap: var(--space-6);
  flex-direction: column;
  ${mobile_xl(css`
    gap: var(--space-0);
  `)}
`;

const Data = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
  --border-top: ${({ isShowCompletedTask }) => (isShowCompletedTask ? 'none' : '0.5px solid var(--border-primary)')};
  --padding-top: ${({ isShowCompletedTask }) => (isShowCompletedTask ? 'var(--space-0)' : 'var(--space-5)')};
  border-top: var(--border-top);
  padding-top: var(--padding-top);
`;

const DropBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  padding: var(--space-1) var(--space-10) var(--space-1) var(--space-6);
  border-left: 0.5px solid var(--border-primary);
  &.left-border {
    border-left: none;
  }
`;
const DotIcon = styled.div<Props>`
  margin: var(--space-4);
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);
  ${(props: Props) =>
    props.color &&
    css`
      background-color: ${props.color};
    `}
`;
const DropLabel = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
  white-space: nowrap;
`;

const TooltipDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const MainTooltipDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

const TaskCount = styled.div<Props>`
  padding: var(--space-1) var(--space-7);
  box-shadow: var(--border);
  border-radius: var(--border-radius-full);
  color: var(--text-primary);
  ${Typography.body_md};
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${({ isActiveSubTask }) =>
    isActiveSubTask &&
    css`
      background-color: var(--neutral-secondary);
    `}
`;
const MultipleLabel = styled.div`
  border-radius: var(--border-radius-full);
  border: 0.5px solid var(--border-primary);
  display: flex;
  ${mobile_xl(css`
    display: none;
  `)}
`;

const IconDueDate = styled.div<Props>`
  .fill-color {
    width: 16px;
    height: 16px;
    fill: var(--text-secondary);
  }
  &:hover .fill-color {
    fill: var(--text-primary);
  }
  &:active .fill-color {
    fill: var(--text-primary);
  }
  .calendar-fill-color {
    fill: var(--text-secondary);
  }
  .calendar-due-fill-color {
    fill: var(--accent-error);
  }
  display: flex;
  p {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    white-space: nowrap;
    margin: var(--space-0);
    h6 {
      ${Typography.body_md}
      color: var(--text-secondary);
      white-space: nowrap;
      margin: var(--space-0);
      &:hover {
        color: var(--text-primary);
      }
    }
  }
  .task-grid-calander-icon {
    display: none;
    padding: var(--space-3);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-4);
    width: 16px;
    height: 16px;
    path {
      fill: var(--text-secondary);
    }
  }
  .task-grid-calander-icon:hover {
    background-color: var(--neutral-secondary);
    border: 0.5px solid transparent;
  }
`;

const OptionDiv = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    flex-wrap: wrap;
  `)}
`;

const Filter = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const TaskNumber = styled.p`
  ${Typography.body_md_medium}
  margin: var(--space-0);
  color: var(--text-primary);
`;

const Text2 = styled.span`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const Show = styled.div`
  p {
    ${Typography.body_md_medium}
    color: var(--brand-primary);
    margin: var(--space-0);
  }
  &:hover {
    cursor: pointer;
  }
`;
const ShowSubTask = styled.div`
  display: flex;
  padding-left: var(--space-8);
`;
const SubTaskList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;
const LineDiv = styled.div`
  width: 5px;
  border: 0.5px solid var(--border-secondary);
  border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-0) var(--border-radius-4);
  border-style: none none solid solid;
  margin-bottom: var(--space-16);
  ${mobile_xl(css`
    margin-bottom: var(--space-20);
  `)}
  ${(props: Props) =>
    props.isApplyMargin &&
    css`
      margin-bottom: var(--space-12);
      ${mobile_xl(css`
        margin-bottom: var(--space-16);
      `)}
    `}
`;

const TooltipContent = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const StatusIcon = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
`;
const ProjectName = styled.div<Props>`
  ${(props: Props) =>
    props.showRightBorder &&
    css`
      padding-right: var(--space-12);
      border-right: 0.5px solid var(--border-primary);
    `}
  p {
    margin: var(--space-0);
    ${Typography.body_md}
    color: var(--text-secondary);
    cursor: pointer;
    padding: var(--space-2) var(--space-8);
    white-space: nowrap;

    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-full);
    }
  }
  ${mobile_xl(css`
    padding-right: var(--space-8);
    p {
      padding: var(--space-0);
    }
  `)}
`;
const OverLay = styled.div<Props>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: var(--z-index-negative);
  border-radius: var(--border-radius-full);

  ${(props: Props) => {
    // Map status type number to background color
    switch (Number(props.statusType)) {
      case STATUS_TYPE.BACKLOG: // BACKLOG
        return css`
          background-color: var(--text-secondary);
          opacity: 0.1;
        `;
      case STATUS_TYPE.UNSTARTED: // UNSTARTED/TODO
        return css`
          background-color: var(--text-secondary);
          opacity: 0.1;
        `;
      case STATUS_TYPE.IN_PROGRESS: // IN_PROGRESS
        return css`
          background-color: var(--accent-highlight);
          opacity: 0.25;
        `;
      case STATUS_TYPE.IN_REVIEW: // IN_REVIEW
        return css`
          background-color: var(--accent-success);
          opacity: 0.25;
        `;
      case STATUS_TYPE.COMPLETED: // COMPLETED/DONE
        return css`
          background-color: var(--text-secondary);
          opacity: 0.1;
        `;
      case STATUS_TYPE.CANCELLED: // CANCELLED
        return css`
          background-color: var(--text-secondary);
          opacity: 0.1;
        `;
      default:
        return;
    }
  }}
`;
export {
  StatusDropdown,
  Group,
  TaskFormation,
  Content,
  ItemBlock,
  Title,
  Tasklist,
  TaskContent,
  TaskItemWrapper,
  Form,
  Label,
  AssignGroup,
  Deadline,
  Text,
  IconHidden,
  AvatarImage,
  DeadBlock,
  ShowTask,
  ShowHide,
  Data,
  DropBlock,
  DotIcon,
  DropLabel,
  TaskCount,
  MultipleLabel,
  IconDueDate,
  OptionDiv,
  Filter,
  TaskNumber,
  Text2,
  Show,
  ShowSubTask,
  SubTaskList,
  LineDiv,
  ButtonIcon,
  TooltipContent,
  TooltipDiv,
  MainTooltipDiv,
  TitleSection,
  StatusIcon,
  ProjectName,
  OverLay
};
